import type { OnyxComponentInputs, OnyxTableColumn } from '@onyx/angular';
import { OnyxDateFormat } from '@onyx/angular';
import { AmountCellComponent } from '../../../../common/components/cells/amount-cell/amount-cell.component';
import { DateCellComponent } from '../../../../common/components/cells/date-cell/date-cell.component';
import type { OrderPaymentHistoryItemData } from '../../order-modal/order-modal-sections/order-modal-summary/order-modal-finished-section/order-modal-payment-form-container/order-modal-payment-form-container.component';

export const getOrderModalPaymentHistoryColumns = (
  type: 'current' | 'history',
): OnyxTableColumn<OrderPaymentHistoryItemData>[] => [
  {
    id: 'date',
    name: 'labels.date',
    width: 'fill',
    component: {
      ref: DateCellComponent,
      inputs: ({ item }): OnyxComponentInputs<DateCellComponent> => ({
        date: item.date,
        format: OnyxDateFormat.DATE,
      }),
    },
  },
  {
    id: 'netAmount',
    name: 'labels.netAmount',
    width: type === 'history' ? '170px' : 'fill',
    component: {
      ref: AmountCellComponent,
      inputs: ({ item }): OnyxComponentInputs<AmountCellComponent> => ({
        amount: item.net,
        short: false,
      }),
    },
  },
  {
    id: 'vatAmount',
    name: 'labels.vatAmount',
    width: type === 'history' ? '170px' : 'fill',
    component: {
      ref: AmountCellComponent,
      inputs: ({ item }): OnyxComponentInputs<AmountCellComponent> => ({
        amount: item.vat,
        short: false,
      }),
    },
  },
  ...(type === 'current'
    ? [
        {
          id: 'remainingNet',
          name: 'labels.remainingNet',
          width: 'fill',
          component: {
            ref: AmountCellComponent,
            inputs: ({
              item,
            }: {
              item: OrderPaymentHistoryItemData;
            }): OnyxComponentInputs<AmountCellComponent> => ({
              amount: item.remainingNet,
              short: false,
            }),
          },
        } as const,
      ]
    : []),
  ...(type === 'current'
    ? [
        {
          id: 'remainingVat',
          name: 'labels.remainingVat',
          width: 'fill',
          component: {
            ref: AmountCellComponent,
            inputs: ({
              item,
            }: {
              item: OrderPaymentHistoryItemData;
            }): OnyxComponentInputs<AmountCellComponent> => ({
              amount: item.remainingVat,
              short: false,
            }),
          },
        } as const,
      ]
    : []),
];
